import { useEffect, useRef, useState } from "react";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Calendar } from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";
import { useLocation } from "react-router-dom";
import { Snackbar } from "components";
import { ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import printJS from "print-js";
import { Sheet, SheetContent } from "components/ui/sheet";
import useStaffAction from "./useStaffAction";
import useUrlString from "pages/business-suite/useUrlString";
import DailogRoster from "pages/business-suite/dialogStaff/DailogRoster";
import PageEditAndAddStaff from "pages/business-suite/dialogStaff/PageEditAndAddStaff";
import DialogUploadStaff from "pages/business-suite/dialogStaff/DialogUploadStaff";
import StaffNavbar from "./StaffNavbar";
import StaffDepartment from "./StaffDepartment";
import Status from "../Status";
import StaffCard from "./StaffCard";
import StaffTable from "./StaffTable";
export default function Staff() {
  //*=============================================================Store Glogbal State========================================
  const dataStaff: any = useStaffAction();
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();
  const { btnToggle, btnSearchStaff, btnSearchProduct } = useAppSelector((state) => state.header);
  const { token } = useAppSelector((state) => state.auth);
  //*===================================================Function=====================================================================
  const getShopEmployeeDetail = async (id: any) => {
    setLoadingFetchDataShopEmployeeDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataShopEmployeeDetail(false);
        setShopEmployeeDetail(response.user_shop_employee);
      } else {
      }
    } catch (error: any) {
      setLoadingFetchDataShopEmployeeDetail(false);

      AppLog.show({
        message: `[submitUndoDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const changeView = (selectedView: string) => {
    dataStaff?.setView(selectedView);
    localStorage.setItem("staff-display-layout", selectedView);
  };
  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      dataStaff?.setSelectedProductIds([]);
    } else {
      dataStaff?.setSelectedProductIds(allIds);
    }
  };
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${dataStaff?.storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-head-count-report?token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: dataStaff?.searchTextInput,
        department: dataStaff?.selectedProductGroupCode,
        storage_host_cluster_id: dataStaff?.storage_host_cluster_Id.id,
        working_date: dataStaff?.dobStaff,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      dataStaff?.setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const toggleItem = (item: any) => {
    setFilteredData((prev) => {
      const exists = prev.some((i) => i.id === item.id);
      return exists ? prev.filter((i) => i.id !== item.id) : [...prev, item];
    });
  };
  const handleClick = (title: string) => {
    // setLoading(true);
    if (title === "Roster Setup") {
      setIsDailogIsRoster(true);
      const dataToFilter = Array.isArray(dataStaff?.shopEmployee?.data) ? dataStaff?.shopEmployee?.data : [];
      const result = dataToFilter.filter((item: any) => dataStaff?.selectedProductIds.includes(item.id));
      setFilteredData(result);
      // setLoading(false);
    } else {
      Snackbar({
        message: "Coming soon",
        status: StatusMsg.warning,
      });
    }
  };
  //*==================================================================Variable===========================================================
  const location = useLocation();
  useState<boolean>(false);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  const [hovered, setHovered] = useState(false);
  const listRef = useRef<any>(null);
  const [editEmloyeeId, setEditEmloyeeId] = useState<any>(null);
  const [isCreateStaff, setIsCreateStaff] = useState<boolean>(false);
  const [shiftGroupId, setShiftGroupId] = useState<any>();
  const [loadingFetchDataShopEmployeeDetail, setLoadingFetchDataShopEmployeeDetail] = useState<boolean>(false);
  const [ShopEmployeeDetail, setShopEmployeeDetail] = useState<any>(null);
  const allIds = Array.isArray(dataStaff?.shopEmployee?.data) ? dataStaff?.shopEmployee?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => dataStaff?.selectedProductIds.includes(id));
  const [isDailogRoster, setIsDailogIsRoster] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [isDailogUploadStaff, setIsDailogUploadStaff] = useState(false);
  //*====================================================================Ueffect================================================================
  useEffect(() => {
    if (listRef.current && dataStaff?.shopEmployeeLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataStaff?.fetchMoreShopEmployeeSearch({
        next: dataStaff?.shopEmployeeLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStaff?.shopEmployee?.data]);

  useEffect(() => {
    dataStaff?.getShopEmployeeSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStaff?.searchTextInput, dataStaff?.selectedProductGroupCode, btnToggle, btnSearchStaff, dataStaff?.dobStaff, btnSearchProduct]);

  useEffect(() => {
    dataStaff?.fetchDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const savedView = localStorage.getItem("staff-display-layout");
    if (savedView) {
      dataStaff?.setView(savedView);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStaff?.searchTextInput, dataStaff?.selectedProductGroupCode]);

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("staff_id");
    if (requestId) {
      (async () => {
        await getShopEmployeeDetail(requestId);
        setIsCreateStaff(false);
        setOpenPopoverIndex(1);
        setEditEmloyeeId(requestId);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dataTimesheets = [
    {
      id: 1,
      title: "Roster Setup",
      label: "Scheduling Assigned per Operational",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calendar className="" />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm dark:text-white">Configure employee work schedules, shifts, and availability across days or weeks.</p>
          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
            <li>Assign shifts to employees based on roles, departments, or availability.</li>
            <li>Customize working hours, break times, and rotation patterns.</li>
            <li>Ensure proper staffing coverage and reduce scheduling conflicts.</li>
            <li>Essential for accurate timesheets and payroll calculations.</li>
          </ul>
        </>,
      ],
    },
  ];
  // ==========================================================================Prop=================================================================
  const staffNavbarProp = {
    selectProducts: dataStaff?.selectProducts,
    selectedProductIds: dataStaff?.selectedProductIds,
    allIds: allIds,
    setOpenPopoverIndex: setOpenPopoverIndex,
    setSelectProducts: dataStaff?.setSelectProducts,
    isAllSelected: isAllSelected,
    handleToggleSelectAll: handleToggleSelectAll,
    setSelectedProductIds: dataStaff?.setSelectedProductIds,
    handlePrint: handlePrint,
    loadingPrint: loadingPrint,
    setSearchTextInput: dataStaff?.setSearchTextInput,
    view: dataStaff?.view,
    changeView: changeView,
    setIsCreateStaff: setIsCreateStaff,
    setShopEmployeeDetail: setShopEmployeeDetail,
    setLoadingFetchDataShopEmployeeDetail: setLoadingFetchDataShopEmployeeDetail,
    dataTimesheets: dataTimesheets,
    handleClick: handleClick,
    submitDeleteShopEmployee: dataStaff?.submitDeleteShopEmployee,
    submitUndoDeleteShopEmployee: dataStaff?.submitUndoDeleteShopEmployee,
    dobStaff: dataStaff?.dobStaff,
    setDobStaff: dataStaff?.setDobStaff,
  };
  const staffDepartment = {
    setHovered: setHovered,
    hovered: hovered,
    setEditItemCategories: setEditItemCategories,
    handleClickCategory: dataStaff?.handleClickCategory,
    selectedProductGroupCode: dataStaff?.selectedProductGroupCode,
    loadingFetchDataDepartment: dataStaff?.loadingFetchDataDepartment,
    alldepartment: dataStaff?.alldepartment,
  };
  const staffCard = {
    shopEmployee: dataStaff?.shopEmployee,
    fetchMoreShopEmployeeSearch: dataStaff?.fetchMoreShopEmployeeSearch,
    shopEmployeeLoading: dataStaff?.shopEmployeeLoading,
    toggleItem: toggleItem,
    listRef: listRef,
    setOpenPopoverIndex: setOpenPopoverIndex,
    selectProducts: dataStaff?.selectProducts,
    setSelectedProductIds: dataStaff?.setSelectedProductIds,
    selectedProductIds: dataStaff?.selectedProductIds,
    handleClickUrl: handleClickUrl,
    setIsCreateStaff: setIsCreateStaff,
    setEditEmloyeeId: setEditEmloyeeId,
    getShopEmployeeDetail: getShopEmployeeDetail,
    setShopEmployee: dataStaff?.setShopEmployee,
  };
  const staffTable = {
    shopEmployee: dataStaff?.shopEmployee,
    fetchMoreShopEmployeeSearch: dataStaff?.fetchMoreShopEmployeeSearch,
    shopEmployeeLoading: dataStaff?.shopEmployeeLoading,
    toggleItem: toggleItem,
    listRef: listRef,
    setOpenPopoverIndex: setOpenPopoverIndex,
    selectProducts: dataStaff?.selectProducts,
    setSelectedProductIds: dataStaff?.setSelectedProductIds,
    selectedProductIds: dataStaff?.selectedProductIds,
    handleClickUrl: handleClickUrl,
    setIsCreateStaff: setIsCreateStaff,
    setEditEmloyeeId: setEditEmloyeeId,
    getShopEmployeeDetail: getShopEmployeeDetail,
    setShopEmployee: dataStaff?.setShopEmployee,
    shopEmployeeLoadingState: dataStaff?.shopEmployeeLoadingState,
  };
  const dialogRosterProp = {
    searchTextInput: dataStaff?.searchTextInput,
    setFilteredData: setFilteredData,
    editItemCategories: editItemCategories,
    filteredData: filteredData,
    isDailogRoster: isDailogRoster,
    setIsDailogIsRoster: setIsDailogIsRoster,
    userShopShiftGroup: dataStaff?.userShopShiftGroup,
  };
  const pageEditStaffProp = {
    setIsDailogUploadStaff: setIsDailogUploadStaff,
    setOpenPopoverIndex: setOpenPopoverIndex,
    editEmloyeeId: editEmloyeeId,
    setEditEmloyeeId: setEditEmloyeeId,
    setShiftGroupId: setShiftGroupId,
    shiftGroupId: shiftGroupId,
    setUserShopShiftGroup: dataStaff?.setUserShopShiftGroup,
    userShopShiftGroup: dataStaff?.userShopShiftGroup,
    isCreateStaff: isCreateStaff,
    setIsCreateStaff: setIsCreateStaff,
    department: dataStaff?.department,
    loadingFetchDataShopEmployeeDetail: loadingFetchDataShopEmployeeDetail,
    ShopEmployeeDetail: ShopEmployeeDetail,
    setShopEmployeeDetail: setShopEmployeeDetail,
    setAllsetDepartment: dataStaff?.setAllsetDepartment,
  };
  const uploadStaffProp = {
    editItemCategories: editItemCategories,
    userShopShiftGroup: dataStaff?.userShopShiftGroup,
    setShopEmployee: dataStaff?.setShopEmployee,
    setAllsetDepartment: dataStaff?.setAllsetDepartment,
    isDailogUploadStaff: isDailogUploadStaff,
    setIsDailogUploadStaff: setIsDailogUploadStaff,
    editEmloyeeId: editEmloyeeId,
    department: dataStaff?.department,
  };
  // ==========================================================================Staff View=================================================================

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white  dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto  w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Staffs</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {dataStaff?.warning ? "" : <StaffNavbar {...staffNavbarProp} />}
        </div>

        {dataStaff?.warning ? "" : <StaffDepartment {...staffDepartment} />}
      </div>

      {dataStaff?.warning ? (
        <Status errorStatus={dataStaff?.errorStatus} className="h-[70vh]" />
      ) : (
        <div className="pb-3 h-full mt-5 ">
          {dataStaff?.view === "card" ? (
            <>
              {dataStaff?.shopEmployeeLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <StaffCard {...staffCard} />
              )}
            </>
          ) : (
            <>{dataStaff?.shopEmployee ? <StaffTable {...staffTable} /> : <></>}</>
          )}
        </div>
      )}

      <DailogRoster
        onUploadSuccessRoster={({ status }) => {
          if (status === "success") {
            dataStaff?.setSelectedProductIds([]);
            dataStaff?.setSelectProducts(false);
          } else {
          }
        }}
        resetStatus={({ status }) => {}}
        {...dialogRosterProp}
      />
      <BtnGoToTop />
      <Sheet
        open={openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          setOpenPopoverIndex(isOpen ? 1 : null);
          setEditEmloyeeId(null);
          if (!isOpen) {
            hanleClickRemoveURl("staff_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1000px] justify-between p-3 pt-[50px]">
          <PageEditAndAddStaff
            onUploadSuccess={({ res, name }) => {
              if (name === "delete") {
                dataStaff?.setShopEmployee((prevItemGroups: any) => {
                  return {
                    ...prevItemGroups,
                    data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
                  };
                });
              } else {
                dataStaff?.setShopEmployee((prevItemGroups: any) => {
                  const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                  const exists = updatedData.some((item: any) => item.id === res.id);
                  if (!exists) {
                    updatedData.push(res);
                  }
                  return {
                    ...prevItemGroups,
                    data: updatedData,
                  };
                });
              }
            }}
            {...pageEditStaffProp}
          />
        </SheetContent>
      </Sheet>
      <DialogUploadStaff {...uploadStaffProp} />
    </BusinessSuiteContentLayout>
  );
}
